import axios from "axios";
import { BASE_URL } from "@src/utils";
import { IndividualHall } from "@src/types/weddingHall";

export const getIndividualHall = (partnerUuid: string, uuid: string) => {
    const url = `${BASE_URL}/v3/book/20240729/partner/hall/${partnerUuid}/individual-halls/${uuid}`;
    const accessToken = localStorage.getItem("accessToken");
    const headers: any = {};

    if (accessToken) headers.Authorization = `bearer ${accessToken}`;

    return axios.get<{ item: IndividualHall }>(url, { headers });
};
